var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 12,
    viewBox: "0 0 22.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.625,22.5H21.691l-2.13,3.2a1.046,1.046,0,0,0-.156,1.143,1.145,1.145,0,0,0,2.031.023l3.375-5.041a1.045,1.045,0,0,0,0-1.2l-3.375-4.681a1.165,1.165,0,0,0-1.579-.284,1.064,1.064,0,0,0-.3,1.516l2.295,3.165H3.625a1.081,1.081,0,1,0,0,2.16Z",
    transform: "translate(-2.5 -15.471)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLine);
export default __webpack_public_path__ + "static/media/arrow-right-line.ad21a8551f2e11113cca30d6054c6d8a.svg";
export { ForwardRef as ReactComponent };